import React from 'react';
import Hero from '../components/Hero';
import About from '../components/About';
import Testimonials from '../components/Testimonials';
import CallToAction from '../components/CallToAction';

const HomePage = () => {
  return (
    <main>
      <Hero />
      <About />
      <Testimonials />
      <CallToAction />
    </main>
  );
};

export default HomePage; 